var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoExpediente(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-ex-258e9fa54cb426ab1f139bf38a88306ac096cfc0057b5e9fcd73546b03680bc3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400.606,
    height: 110.166,
    viewBox: "0 0 400.606 110.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8829",
    "data-name": "Trazado 8829",
    d: "M24.294,61.439H11.4V48.58Z",
    transform: "translate(11.433 48.727)",
    fill: "#37a048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8830",
    "data-name": "Trazado 8830",
    d: "M11.4,48.58h12.9V61.439Z",
    transform: "translate(11.433 48.727)",
    fill: "#8dc63f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8831",
    "data-name": "Trazado 8831",
    d: "M37.183,61.439h-12.9V48.58Z",
    transform: "translate(24.352 48.727)",
    fill: "#8dc63f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8832",
    "data-name": "Trazado 8832",
    d: "M24.279,48.58h12.9V61.439Z",
    transform: "translate(24.352 48.727)",
    fill: "#37a048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8833",
    "data-name": "Trazado 8833",
    d: "M17.836,61.439V48.58h12.9Z",
    transform: "translate(17.89 48.727)",
    fill: "#f89743"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8834",
    "data-name": "Trazado 8834",
    d: "M30.74,48.58V61.439h-12.9Z",
    transform: "translate(17.89 48.727)",
    fill: "#ffc944"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8835",
    "data-name": "Trazado 8835",
    d: "M4.956,61.439V48.58h12.9Z",
    transform: "translate(4.971 48.727)",
    fill: "#37a048"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8836",
    "data-name": "Trazado 8836",
    d: "M17.86,48.58V61.439H4.956Z",
    transform: "translate(4.971 48.727)",
    fill: "#006838"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8837",
    "data-name": "Trazado 8837",
    d: "M17.86,55.013H4.956V42.162Z",
    transform: "translate(4.971 42.29)",
    fill: "#00a79d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8838",
    "data-name": "Trazado 8838",
    d: "M4.956,42.162h12.9V55.013Z",
    transform: "translate(4.971 42.29)",
    fill: "#27aae1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8839",
    "data-name": "Trazado 8839",
    d: "M4.956,48.6V35.744h12.9Z",
    transform: "translate(4.971 35.852)",
    fill: "#194894"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8840",
    "data-name": "Trazado 8840",
    d: "M17.86,35.744V48.6H4.956Z",
    transform: "translate(4.971 35.852)",
    fill: "#3a69b3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8841",
    "data-name": "Trazado 8841",
    d: "M24.325,42.275h-12.9V29.416Z",
    transform: "translate(11.455 29.505)",
    fill: "#3a69b3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8842",
    "data-name": "Trazado 8842",
    d: "M11.421,29.416h12.9V42.275Z",
    transform: "translate(11.455 29.505)",
    fill: "#194894"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8843",
    "data-name": "Trazado 8843",
    d: "M17.86,42.183H4.956V29.324Z",
    transform: "translate(4.971 29.413)",
    fill: "#8dc63f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8844",
    "data-name": "Trazado 8844",
    d: "M4.956,29.324h12.9V42.183Z",
    transform: "translate(4.971 29.413)",
    fill: "#37a048"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8845",
    "data-name": "Trazado 8845",
    d: "M11.485,22.532V9.674h12.9Z",
    transform: "translate(11.52 9.703)",
    fill: "#37a048"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8846",
    "data-name": "Trazado 8846",
    d: "M24.389,9.674V22.532h-12.9Z",
    transform: "translate(11.52 9.703)",
    fill: "#006838"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8847",
    "data-name": "Trazado 8847",
    d: "M8.478,12.859V0h12.9Z",
    transform: "translate(8.504)",
    fill: "#194894"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8848",
    "data-name": "Trazado 8848",
    d: "M21.375,0V12.859H8.478Z",
    transform: "translate(8.504)",
    fill: "#3a69b3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8849",
    "data-name": "Trazado 8849",
    d: "M24.37,22.532V9.674h12.9Z",
    transform: "translate(24.443 9.703)",
    fill: "#ffc944"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8850",
    "data-name": "Trazado 8850",
    d: "M37.274,9.674V22.532H24.37Z",
    transform: "translate(24.443 9.703)",
    fill: "#f89743"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8851",
    "data-name": "Trazado 8851",
    d: "M4.956,29.351V16.492h12.9Z",
    transform: "translate(4.971 16.542)",
    fill: "#00a79d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8852",
    "data-name": "Trazado 8852",
    d: "M17.86,16.523V29.382H4.956Z",
    transform: "translate(4.971 16.573)",
    fill: "#27aae1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8853",
    "data-name": "Trazado 8853",
    d: "M15.236,19.823H5.043V9.674Z",
    transform: "translate(5.058 9.703)",
    fill: "#194894"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8854",
    "data-name": "Trazado 8854",
    d: "M5.043,9.674H15.236V19.823Z",
    transform: "translate(5.058 9.703)",
    fill: "#3a69b3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8855",
    "data-name": "Trazado 8855",
    d: "M0,11.077V3.971H7.132Z",
    transform: "translate(0 3.983)",
    fill: "#ffc944"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8856",
    "data-name": "Trazado 8856",
    d: "M7.132,3.971v7.107H0Z",
    transform: "translate(0 3.983)",
    fill: "#f89743"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8857",
    "data-name": "Trazado 8857",
    d: "M30.831,22.532h-12.9V9.674Z",
    transform: "translate(17.982 9.703)",
    fill: "#37a048"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8858",
    "data-name": "Trazado 8858",
    d: "M17.928,9.674h12.9V22.532Z",
    transform: "translate(17.982 9.703)",
    fill: "#8dc63f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8859",
    "data-name": "Trazado 8859",
    d: "M17.863,42.275V29.416h12.9Z",
    transform: "translate(17.917 29.505)",
    fill: "#27aae1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8860",
    "data-name": "Trazado 8860",
    d: "M30.767,29.416V42.275h-12.9Z",
    transform: "translate(17.917 29.505)",
    fill: "#00a79d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8861",
    "data-name": "Trazado 8861",
    d: "M4.956,35.765V22.906h12.9Z",
    transform: "translate(4.971 22.976)",
    fill: "#3a69b3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8862",
    "data-name": "Trazado 8862",
    d: "M17.86,22.906V35.765H4.956Z",
    transform: "translate(4.971 22.976)",
    fill: "#194894"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8863",
    "data-name": "Trazado 8863",
    d: "M74.12,60.242l-2.734.023a.809.809,0,0,1-.6-.227,2.932,2.932,0,0,1-.357-.439L58.223,42.086a2.753,2.753,0,0,1-.372.81L46.132,59.788c-.129.159-.251.318-.387.462a.694.694,0,0,1-.524.219l-2.6.023,13.7-19.685L42.942,22.332l2.734-.023a.808.808,0,0,1,.554.159,1.692,1.692,0,0,1,.311.378l11.772,16.6a5.353,5.353,0,0,1,.4-.81l11.1-15.947a1.466,1.466,0,0,1,.334-.409.744.744,0,0,1,.471-.166l2.651-.023L60.19,40.61Z",
    transform: "translate(42.752 22.157)",
    fill: "#243348"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8864",
    "data-name": "Trazado 8864",
    d: "M73.518,22q6.744-.056,10.185,2.861c2.294,1.945,3.463,4.73,3.486,8.363a11.022,11.022,0,0,1-.911,4.617A10.407,10.407,0,0,1,83.6,41.494,12.686,12.686,0,0,1,79.351,43.9a17.476,17.476,0,0,1-5.651.893l-7.117.053.122,15.371-2.787.023-.3-38.16Zm.16,20.579a13.682,13.682,0,0,0,4.511-.734,10.012,10.012,0,0,0,3.38-1.968,8.451,8.451,0,0,0,2.111-2.944,8.943,8.943,0,0,0,.714-3.686A8.544,8.544,0,0,0,81.637,26.5q-2.723-2.35-8.111-2.308l-7.117.053.144,18.391Z",
    transform: "translate(63.807 22.071)",
    fill: "#243348"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8865",
    "data-name": "Trazado 8865",
    d: "M104.544,57.685l-.038,2.293-22.945.182L81.257,22l22.944-.182.015,2.293-20.157.159.122,15.424,16.777-.129.015,2.24L84.2,41.935l.129,15.909Z",
    transform: "translate(81.503 21.884)",
    fill: "#243348"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8866",
    "data-name": "Trazado 8866",
    d: "M131.361,40.646a22.5,22.5,0,0,1-1.26,7.962,17.258,17.258,0,0,1-3.684,6.04,16.133,16.133,0,0,1-5.751,3.845,20.163,20.163,0,0,1-7.419,1.377l-13.991.106-.3-38.16,13.99-.106a20.132,20.132,0,0,1,7.435,1.264,16.2,16.2,0,0,1,5.811,3.754,17.183,17.183,0,0,1,3.782,5.987A22.492,22.492,0,0,1,131.361,40.646Zm-2.87.023a21.369,21.369,0,0,0-1.162-7.107,14.891,14.891,0,0,0-3.183-5.26,13.484,13.484,0,0,0-4.9-3.255,16.681,16.681,0,0,0-6.288-1.082l-11.2.091.264,33.679,11.2-.091a16.669,16.669,0,0,0,6.265-1.181,13.4,13.4,0,0,0,4.847-3.33,14.738,14.738,0,0,0,3.1-5.313A21.112,21.112,0,0,0,128.491,40.669Z",
    transform: "translate(99.253 21.775)",
    fill: "#243348"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8867",
    "data-name": "Trazado 8867",
    d: "M124.607,59.738l-2.788.023-.3-38.16,2.788-.023Z",
    transform: "translate(121.882 21.643)",
    fill: "#243348"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8868",
    "data-name": "Trazado 8868",
    d: "M153.867,57.3l-.038,2.293-22.945.182-.3-38.16,22.945-.182.016,2.293-20.157.159.12,15.424,16.777-.129.016,2.24-16.777.129.128,15.909Z",
    transform: "translate(130.976 21.495)",
    fill: "#243348"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8869",
    "data-name": "Trazado 8869",
    d: "M177.832,21.264l.3,38.16-1.3.008a1.335,1.335,0,0,1-.585-.114,1.416,1.416,0,0,1-.449-.416L150.673,25.986a13.894,13.894,0,0,1,.092,1.537l.25,32.113-2.438.023-.3-38.16,1.382-.008a1.5,1.5,0,0,1,.585.091,1.236,1.236,0,0,1,.449.416l25.078,32.839a13.881,13.881,0,0,1-.09-1.536l-.252-32.007Z",
    transform: "translate(148.722 21.328)",
    fill: "#243348"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8870",
    "data-name": "Trazado 8870",
    d: "M198.055,23.452l-13.45.106.28,35.814-2.788.023-.28-35.814-13.526.106-.016-2.346,29.765-.235Z",
    transform: "translate(168.784 21.169)",
    fill: "#243348"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8871",
    "data-name": "Trazado 8871",
    d: "M211.661,56.841l-.038,2.293-22.945.182-.3-38.16,22.945-.182.016,2.293-20.156.159.12,15.424,16.777-.129.016,2.24-16.777.129L191.443,57Z",
    transform: "translate(188.945 21.038)",
    fill: "#243348"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8872",
    "data-name": "Trazado 8872",
    d: "M100.062,47.6a7.894,7.894,0,0,1,2.248-1.6,6.375,6.375,0,0,1,2.666-.537,4.828,4.828,0,0,1,1.915.356,3.542,3.542,0,0,1,1.358,1,4.258,4.258,0,0,1,.805,1.567,7.179,7.179,0,0,1,.266,2.051l-.03,8.825h-.517a.474.474,0,0,1-.509-.386l-.182-1.741a12.875,12.875,0,0,1-1.118.976,6.713,6.713,0,0,1-1.162.734,6.431,6.431,0,0,1-1.3.462,6.864,6.864,0,0,1-1.534.159,4.282,4.282,0,0,1-1.352-.212,3.423,3.423,0,0,1-1.17-.628,3,3,0,0,1-.82-1.09,3.735,3.735,0,0,1-.3-1.589,2.789,2.789,0,0,1,.494-1.589,3.911,3.911,0,0,1,1.55-1.272,10.145,10.145,0,0,1,2.7-.863,23.617,23.617,0,0,1,3.956-.371l.008-1.415a4.564,4.564,0,0,0-.805-2.9,2.887,2.887,0,0,0-2.408-1.022,4.627,4.627,0,0,0-1.679.265,5.83,5.83,0,0,0-1.17.6,8.111,8.111,0,0,0-.781.6.848.848,0,0,1-.509.272.4.4,0,0,1-.244-.068.587.587,0,0,1-.159-.174Zm7.982,5.109a24.507,24.507,0,0,0-3.341.3,9.94,9.94,0,0,0-2.31.636,3.543,3.543,0,0,0-1.352.969A2.064,2.064,0,0,0,100.6,55.9a2.951,2.951,0,0,0,.22,1.181,2.206,2.206,0,0,0,.6.817,2.426,2.426,0,0,0,.867.469,3.531,3.531,0,0,0,1.026.151A5.563,5.563,0,0,0,106,57.883a6.345,6.345,0,0,0,1.064-.727c.326-.28.653-.583.971-.908Z",
    transform: "translate(99.626 45.608)",
    fill: "#243348"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8873",
    "data-name": "Trazado 8873",
    d: "M108.6,48.985a8.989,8.989,0,0,1,.721-1.476,4.771,4.771,0,0,1,.935-1.1,3.876,3.876,0,0,1,1.176-.681,4.163,4.163,0,0,1,1.444-.235,5.125,5.125,0,0,1,.835.076,2.1,2.1,0,0,1,.721.265l-.114.9a.268.268,0,0,1-.258.219,1.938,1.938,0,0,1-.5-.1,3.145,3.145,0,0,0-.881-.1,3.852,3.852,0,0,0-1.4.235,3.128,3.128,0,0,0-1.094.711,4.614,4.614,0,0,0-.851,1.173,11.852,11.852,0,0,0-.669,1.612l-.03,8.772-1.314-.008L107.36,45.7h.7a.431.431,0,0,1,.326.1.553.553,0,0,1,.122.325Z",
    transform: "translate(107.639 45.634)",
    fill: "#243348"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8874",
    "data-name": "Trazado 8874",
    d: "M114.335,51.12a6.785,6.785,0,0,1,2.087-1.877,5.489,5.489,0,0,1,2.766-.681,5.275,5.275,0,0,1,2.2.454,4.466,4.466,0,0,1,1.64,1.3,5.91,5.91,0,0,1,1.026,2.081,10.165,10.165,0,0,1,.351,2.8,10.415,10.415,0,0,1-.411,3,6.8,6.8,0,0,1-1.162,2.316A5.03,5.03,0,0,1,120.973,62a5.643,5.643,0,0,1-2.508.515A5.1,5.1,0,0,1,116,61.95a4.959,4.959,0,0,1-1.747-1.65l-.1,1.673a.342.342,0,0,1-.373.341h-.789l.068-19.822h1.314Zm-.024,8.242a4.306,4.306,0,0,0,3.874,2.127,4.915,4.915,0,0,0,2.127-.431,4.033,4.033,0,0,0,1.518-1.241,5.538,5.538,0,0,0,.919-1.968,10.423,10.423,0,0,0,.31-2.6,6.7,6.7,0,0,0-1.108-4.223,3.8,3.8,0,0,0-3.137-1.43,4.587,4.587,0,0,0-2.53.689,6.907,6.907,0,0,0-1.943,1.93Z",
    transform: "translate(113.333 42.621)",
    fill: "#243348"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8875",
    "data-name": "Trazado 8875",
    d: "M123.6,43.93a1,1,0,0,1-.106.454,1.321,1.321,0,0,1-.266.371,1.266,1.266,0,0,1-.379.257,1.208,1.208,0,0,1-.465.091,1.061,1.061,0,0,1-.463-.1,1.23,1.23,0,0,1-.637-.636,1.132,1.132,0,0,1-.092-.454,1.112,1.112,0,0,1,.1-.469,1.175,1.175,0,0,1,.258-.386,1.239,1.239,0,0,1,.389-.257,1.2,1.2,0,0,1,.463-.091,1.055,1.055,0,0,1,.463.1,1.207,1.207,0,0,1,.381.257,1.4,1.4,0,0,1,.266.386A1.28,1.28,0,0,1,123.6,43.93Zm-.577,4.67-.046,13.555-1.3-.008.046-13.555Z",
    transform: "translate(121.555 42.84)",
    fill: "#243348"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8876",
    "data-name": "Trazado 8876",
    d: "M129.686,61.832a2.894,2.894,0,0,1-2.149-.772,3.226,3.226,0,0,1-.767-2.361l.03-9.264-1.953-.008a.362.362,0,0,1-.242-.083.293.293,0,0,1-.09-.235V48.6l2.324-.159.34-4.851a.451.451,0,0,1,.114-.219.274.274,0,0,1,.236-.091h.615l-.016,5.177,4.292.015v.969l-4.292-.015-.03,9.2a2.8,2.8,0,0,0,.144.961,1.772,1.772,0,0,0,.395.666,1.554,1.554,0,0,0,.593.386,2.32,2.32,0,0,0,.737.129,2.427,2.427,0,0,0,.851-.136,3.36,3.36,0,0,0,.615-.31,4.172,4.172,0,0,0,.425-.31.5.5,0,0,1,.258-.144.3.3,0,0,1,.22.136l.357.575a3.805,3.805,0,0,1-1.32.916A4.309,4.309,0,0,1,129.686,61.832Z",
    transform: "translate(124.891 43.412)",
    fill: "#243348"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8877",
    "data-name": "Trazado 8877",
    d: "M132.043,49.061a8.848,8.848,0,0,1,.721-1.476,4.718,4.718,0,0,1,.933-1.1,3.757,3.757,0,0,1,1.178-.681,4.147,4.147,0,0,1,1.442-.235,5.084,5.084,0,0,1,.835.076,2.27,2.27,0,0,1,.723.265l-.114.9a.271.271,0,0,1-.258.22,1.922,1.922,0,0,1-.5-.1,3.146,3.146,0,0,0-.881-.1,3.856,3.856,0,0,0-1.406.235,3.128,3.128,0,0,0-1.094.711,4.813,4.813,0,0,0-.849,1.173,11.375,11.375,0,0,0-.669,1.612l-.03,8.772-1.314-.008.044-13.555h.7a.431.431,0,0,1,.326.1.539.539,0,0,1,.122.325Z",
    transform: "translate(131.155 45.71)",
    fill: "#243348"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8878",
    "data-name": "Trazado 8878",
    d: "M136.628,47.726a7.9,7.9,0,0,1,2.249-1.6,6.369,6.369,0,0,1,2.666-.537,4.818,4.818,0,0,1,1.913.356,3.551,3.551,0,0,1,1.36,1,4.261,4.261,0,0,1,.805,1.567,7.178,7.178,0,0,1,.266,2.051l-.032,8.825h-.515a.474.474,0,0,1-.509-.386l-.182-1.741a12.877,12.877,0,0,1-1.118.976,6.791,6.791,0,0,1-1.162.734,6.431,6.431,0,0,1-1.3.462,6.889,6.889,0,0,1-1.534.159,4.273,4.273,0,0,1-1.352-.212,3.408,3.408,0,0,1-1.17-.628,3.006,3.006,0,0,1-.821-1.09,3.746,3.746,0,0,1-.3-1.589,2.788,2.788,0,0,1,.493-1.589,3.908,3.908,0,0,1,1.55-1.272,10.121,10.121,0,0,1,2.7-.863,23.573,23.573,0,0,1,3.956-.371l.008-1.415a4.564,4.564,0,0,0-.805-2.9,2.887,2.887,0,0,0-2.408-1.022,4.624,4.624,0,0,0-1.679.265,5.8,5.8,0,0,0-1.17.6,8.47,8.47,0,0,0-.783.6.837.837,0,0,1-.509.272.4.4,0,0,1-.242-.068.6.6,0,0,1-.16-.174Zm7.984,5.109a24.6,24.6,0,0,0-3.343.3,9.958,9.958,0,0,0-2.307.636,3.527,3.527,0,0,0-1.352.969,2.064,2.064,0,0,0-.441,1.287,2.955,2.955,0,0,0,.22,1.181,2.274,2.274,0,0,0,.6.817,2.4,2.4,0,0,0,.865.469,3.542,3.542,0,0,0,1.026.151,5.585,5.585,0,0,0,2.69-.636,6.249,6.249,0,0,0,1.062-.727c.328-.28.655-.583.973-.908Z",
    transform: "translate(136.305 45.73)",
    fill: "#243348"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8879",
    "data-name": "Trazado 8879",
    d: "M146.961,48.672l-.054,15.288a3.852,3.852,0,0,1-.212,1.309,2.894,2.894,0,0,1-.607,1.037,2.8,2.8,0,0,1-1.018.689,3.734,3.734,0,0,1-1.428.25,3.427,3.427,0,0,1-.715-.068,2.617,2.617,0,0,1-.615-.22l.068-.651c.032-.083.062-.129.106-.144a.365.365,0,0,1,.182,0c.076.015.176.03.3.053a2.413,2.413,0,0,0,.449.038,2.106,2.106,0,0,0,1.64-.59,2.48,2.48,0,0,0,.539-1.7l.054-15.288ZM147.53,44a1,1,0,0,1-.106.454,1.23,1.23,0,0,1-.272.371,1.338,1.338,0,0,1-.389.257,1.2,1.2,0,0,1-.463.091,1.055,1.055,0,0,1-.463-.1,1.2,1.2,0,0,1-.381-.257,1.189,1.189,0,0,1-.258-.378,1.166,1.166,0,0,1-.09-.454,1.238,1.238,0,0,1,.357-.855,1.149,1.149,0,0,1,.387-.257,1.206,1.206,0,0,1,.463-.091,1.064,1.064,0,0,1,.465.1,1.33,1.33,0,0,1,.387.257,1.269,1.269,0,0,1,.274.386A1.34,1.34,0,0,1,147.53,44Z",
    transform: "translate(142.743 42.913)",
    fill: "#243348"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8880",
    "data-name": "Trazado 8880",
    d: "M148.665,52.075v.257a9.3,9.3,0,0,0,.349,2.687,5.568,5.568,0,0,0,1,1.945,4.161,4.161,0,0,0,1.58,1.181,5.22,5.22,0,0,0,2.073.4,6.2,6.2,0,0,0,1.777-.219,7.1,7.1,0,0,0,1.268-.5,8.159,8.159,0,0,0,.813-.5.878.878,0,0,1,.441-.22.3.3,0,0,1,.272.136l.359.439a3.631,3.631,0,0,1-.873.757,6.234,6.234,0,0,1-1.208.606,8.164,8.164,0,0,1-1.42.394,8.04,8.04,0,0,1-1.528.144,6.462,6.462,0,0,1-2.544-.492,5.386,5.386,0,0,1-1.967-1.415,6.46,6.46,0,0,1-1.26-2.27,9.552,9.552,0,0,1-.433-3.073,8.255,8.255,0,0,1,.425-2.687A6.165,6.165,0,0,1,149,47.527a5.5,5.5,0,0,1,1.929-1.393,6.4,6.4,0,0,1,2.59-.5,5.662,5.662,0,0,1,2.133.4,4.9,4.9,0,0,1,1.711,1.158,5.472,5.472,0,0,1,1.138,1.862,7.226,7.226,0,0,1,.411,2.535.737.737,0,0,1-.084.409.306.306,0,0,1-.272.106Zm9.076-.8a5.762,5.762,0,0,0-.3-1.953,4.187,4.187,0,0,0-.865-1.468,3.73,3.73,0,0,0-1.328-.923,4.431,4.431,0,0,0-1.7-.325,5.327,5.327,0,0,0-1.891.318,4.13,4.13,0,0,0-1.442.938,4.512,4.512,0,0,0-.979,1.468,6.9,6.9,0,0,0-.5,1.922Z",
    transform: "translate(147.813 45.773)",
    fill: "#243348"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8881",
    "data-name": "Trazado 8881",
    d: "M172.084,45.817,166.3,59.357l-1.148-.008-5.695-13.57h1.026a.491.491,0,0,1,.471.333l4.465,10.709a10.1,10.1,0,0,1,.326,1.188,7.752,7.752,0,0,1,.351-1.181l4.549-10.679a.665.665,0,0,1,.182-.242.446.446,0,0,1,.28-.091Z",
    transform: "translate(159.938 45.918)",
    fill: "#243348"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8882",
    "data-name": "Trazado 8882",
    d: "M170.216,44.08a1,1,0,0,1-.106.454,1.321,1.321,0,0,1-.266.371,1.292,1.292,0,0,1-.379.257,1.208,1.208,0,0,1-.465.091,1.061,1.061,0,0,1-.463-.1,1.2,1.2,0,0,1-.381-.257,1.223,1.223,0,0,1-.258-.378,1.166,1.166,0,0,1-.09-.454,1.112,1.112,0,0,1,.1-.469,1.175,1.175,0,0,1,.258-.386,1.24,1.24,0,0,1,.389-.257,1.2,1.2,0,0,1,.463-.091,1.058,1.058,0,0,1,.463.1,1.2,1.2,0,0,1,.381.257,1.393,1.393,0,0,1,.264.386A1.273,1.273,0,0,1,170.216,44.08Zm-.569,4.67L169.6,62.3l-1.3-.008.046-13.555Z",
    transform: "translate(168.316 42.991)",
    fill: "#243348"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8883",
    "data-name": "Trazado 8883",
    d: "M173.141,49.192a8.85,8.85,0,0,1,.723-1.476,4.72,4.72,0,0,1,.933-1.1,3.735,3.735,0,0,1,1.178-.681,4.147,4.147,0,0,1,1.442-.235,5.105,5.105,0,0,1,.835.076,2.245,2.245,0,0,1,.721.265l-.114.9a.268.268,0,0,1-.256.22,1.934,1.934,0,0,1-.5-.1,3.128,3.128,0,0,0-.881-.1,3.848,3.848,0,0,0-1.4.235,3.125,3.125,0,0,0-1.094.711,4.867,4.867,0,0,0-.851,1.173A11.613,11.613,0,0,0,173.2,50.7l-.032,8.772-1.314-.008.046-13.555h.7a.431.431,0,0,1,.326.1.552.552,0,0,1,.122.325Z",
    transform: "translate(172.378 45.842)",
    fill: "#243348"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8884",
    "data-name": "Trazado 8884",
    d: "M181.978,62a2.894,2.894,0,0,1-2.149-.772,3.18,3.18,0,0,1-.767-2.361l.03-9.264-1.951-.008a.367.367,0,0,1-.244-.083.293.293,0,0,1-.09-.235v-.507l2.324-.159.342-4.851a.42.42,0,0,1,.114-.219.289.289,0,0,1,.234-.091h.615l-.014,5.177,4.29.015v.969l-4.29-.015-.03,9.2a2.751,2.751,0,0,0,.144.961,1.719,1.719,0,0,0,.395.666,1.543,1.543,0,0,0,.591.386,2.323,2.323,0,0,0,.737.129,2.419,2.419,0,0,0,.851-.136,3.3,3.3,0,0,0,.615-.31,4.172,4.172,0,0,0,.425-.31.508.508,0,0,1,.258-.144.3.3,0,0,1,.22.136l.359.575a3.835,3.835,0,0,1-1.322.916A4.389,4.389,0,0,1,181.978,62Z",
    transform: "translate(177.342 43.585)",
    fill: "#243348"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8885",
    "data-name": "Trazado 8885",
    d: "M193.722,45.889l-.046,13.555h-.721a.368.368,0,0,1-.395-.356l-.114-2.013a7.661,7.661,0,0,1-2.187,1.869,5.411,5.411,0,0,1-2.758.7,4.971,4.971,0,0,1-1.981-.363,3.7,3.7,0,0,1-1.406-1.029,4.565,4.565,0,0,1-.843-1.612,7.379,7.379,0,0,1-.28-2.127l.03-8.666h1.314l-.03,8.666a4.651,4.651,0,0,0,.865,3,3.2,3.2,0,0,0,2.66,1.09,4.884,4.884,0,0,0,2.482-.666,6.965,6.965,0,0,0,2.067-1.869l.03-10.187Z",
    transform: "translate(183.544 45.983)",
    fill: "#243348"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8886",
    "data-name": "Trazado 8886",
    d: "M191.6,47.906a7.959,7.959,0,0,1,2.247-1.6,6.255,6.255,0,0,1,2.666-.537,4.814,4.814,0,0,1,1.913.356,3.548,3.548,0,0,1,1.36,1,4.26,4.26,0,0,1,.805,1.567,7.177,7.177,0,0,1,.266,2.051l-.03,8.825h-.517a.474.474,0,0,1-.509-.386l-.182-1.741a12.9,12.9,0,0,1-1.118.976,6.79,6.79,0,0,1-1.162.734,6.442,6.442,0,0,1-1.3.462,6.888,6.888,0,0,1-1.534.159,4.282,4.282,0,0,1-1.352-.212,3.426,3.426,0,0,1-1.17-.628,3.043,3.043,0,0,1-.821-1.082,3.746,3.746,0,0,1-.3-1.589,2.788,2.788,0,0,1,.493-1.589,3.908,3.908,0,0,1,1.55-1.272,10.113,10.113,0,0,1,2.7-.863,23.576,23.576,0,0,1,3.956-.371l.008-1.415a4.564,4.564,0,0,0-.805-2.9,2.887,2.887,0,0,0-2.408-1.022,4.62,4.62,0,0,0-1.679.265,5.787,5.787,0,0,0-1.17.6,8.153,8.153,0,0,0-.781.6.866.866,0,0,1-.511.272.4.4,0,0,1-.242-.068.563.563,0,0,1-.158-.174Zm7.982,5.109a24.6,24.6,0,0,0-3.343.3,9.949,9.949,0,0,0-2.307.636,3.543,3.543,0,0,0-1.352.969,2.065,2.065,0,0,0-.441,1.287,2.953,2.953,0,0,0,.22,1.181,2.3,2.3,0,0,0,.6.817,2.41,2.41,0,0,0,.867.469,3.528,3.528,0,0,0,1.024.151,5.579,5.579,0,0,0,2.69-.636,6.344,6.344,0,0,0,1.064-.727c.327-.28.653-.583.971-.908Z",
    transform: "translate(191.44 45.902)",
    fill: "#243348"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8887",
    "data-name": "Trazado 8887",
    d: "M200.3,42.779l-.07,19.822-1.312-.008.068-19.822Z",
    transform: "translate(199.519 42.901)",
    fill: "#243348"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8888",
    "data-name": "Trazado 8888",
    d: "M44.777,42.335h-12.9V29.477Z",
    transform: "translate(31.97 29.566)",
    fill: "#3a69b3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8889",
    "data-name": "Trazado 8889",
    d: "M31.874,29.477h12.9V42.335Z",
    transform: "translate(31.97 29.566)",
    fill: "#194894"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExpediente);
export default __webpack_public_path__ + "static/media/logo_expediente.9581b28b9a6fca12c9597293e16ce29e.svg";
export { ForwardRef as ReactComponent };